import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/hirefit-b2b/hirefit-b2b/src/app/kolleno/implementation-manager/ClientPage.tsx");
